import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addMessage, deleteMessage, updateMessage } from "../../../../../shared/store/redux/entities-action";
import ConfirmDeletePopup from "../../../../../shared/components/features/message/confirmDeletePopup/ConfirmDeletePopup";
import actionType from "../../../../../shared/enums/actionType";
import MessageEditorPopup from "../../../../../shared/components/features/message/messageEditorPopup/MessageEditorPopup";
import MessageLine from "../MessagesInputArea/MessageLine/MessageLine";
import boardType from "../../../../../shared/enums/boardType";
import targetGroupType from "../../../../../shared/enums/targetGroupType";

const MessagesWidgetEditorFlow = ({ className, messageDraft, setMessageDraft, studyGroups = [], boardId = boardType.dashboardMessages, homeroomClass = false, }) => {

    const dispatch = useDispatch();
    const { texts, lang } = useSelector(state => state.translate);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const openNew = () => setMessageDraft({ draft: { studyGroupId: studyGroups[0], boardId, }, type: actionType.add, });
    const closeEditor = () => setMessageDraft({ draft: null, type: null, });

    const handleDraftChange = (draftUpdate) =>
        setMessageDraft((messageEditor) => ({
            ...messageEditor,
            draft: { ...messageEditor.draft, ...draftUpdate },
        }));

    const handleAction = async (actionFn) => {
        if (isSubmitting || !messageDraft?.draft)
            return;
        setIsSubmitting(true);
        try {
            const payload = {
                id: messageDraft.draft.id,
                fromDate: messageDraft.draft.fromDate,
                toDate: messageDraft.draft.toDate,
                boardId,
                tags: ["user"],
                messageContents: [
                    { lang: "", content: messageDraft.draft.content, imageFile: messageDraft.draft.imageFile },
                ],
                messageFilters: [
                    {
                        studyGroupId: messageDraft.draft.studyGroupId,
                        targetGroup: targetGroupType.Student,
                    },
                ],
            };

            const result = await dispatch(actionFn(payload));

            if (result?.ok)
                setMessageDraft({ draft: null, type: null, });
            else
                console.error("handlePublish", result?.error);
        }
        catch (error) {
            console.error("handlePublish", error);
        }
        finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className={className}>
            <MessageLine onOpen={openNew} />
            {messageDraft.type === actionType.add ?
                <MessageEditorPopup
                    titleText={texts.newMessage}
                    publishText={texts.publishMessageBtn}
                    draft={messageDraft?.draft}
                    onDraftChange={handleDraftChange}
                    onClose={closeEditor}
                    onPublish={() => handleAction(addMessage)}
                    studyGroups={studyGroups}
                    homeroomClass={homeroomClass}
                    isSubmitting={isSubmitting}
                />
                :
                messageDraft.type === actionType.edit ?
                    <MessageEditorPopup
                        titleText={texts.editMessage}
                        publishText={texts.keep}
                        draft={messageDraft?.draft}
                        onDraftChange={handleDraftChange}
                        onClose={closeEditor}
                        onPublish={() => handleAction(updateMessage)}
                        studyGroups={studyGroups}
                        homeroomClass={homeroomClass}
                        isSubmitting={isSubmitting}
                    />
                    : messageDraft.type === actionType.delete ?
                        <ConfirmDeletePopup onClose={() => setMessageDraft({ draft: null, type: null })} onClick={() => handleAction(deleteMessage)} isSubmitting={isSubmitting} />
                        : null
            }
        </div>
    );
};

export default MessagesWidgetEditorFlow;